import { PromotionsRepository } from '@lib/api/repository/promotions/promotions.repository';
import { PromotionsUseCase } from '@lib/interfaces/usecase/promotions.use-case';

import {
  PromotionInput,
  PromotionOfferFilters,
  PromotionOfferType,
} from '@lib/types';

export default class PromotionsService implements PromotionsUseCase {
  constructor(private repository: PromotionsRepository) {}

  listPublic(slug: string, signal?: AbortSignal) {
    return this.repository.listPublic(slug, signal);
  }

  list(signal?: AbortSignal) {
    return this.repository.list(signal);
  }

  listOffers(
    type: PromotionOfferType,
    gameCode: string | undefined,
    search: string | undefined,
    page: number,
    signal?: AbortSignal,
    filters?: PromotionOfferFilters,
  ) {
    return this.repository.listOffers(
      type,
      gameCode,
      search,
      page,
      signal,
      filters,
    );
  }

  preview(input: PromotionInput) {
    return this.repository.preview(input);
  }

  create(input: PromotionInput) {
    return this.repository.create(input);
  }

  update(id: string, input: PromotionInput) {
    return this.repository.update(id, input);
  }

  end(id: string) {
    return this.repository.end(id);
  }
}
